import { ActionBase } from '../../../core/store/action/ActionBase';

export const GET_NOTIFICATION_TYPES = '[Customer] User Get Notification Types';

export class GetNotificationTypesAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_NOTIFICATION_TYPES;
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GetNotificationTypesAction.ts